import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpRequestPayload } from '@core/models';
// import { AuthService } from 'src/app/core/services/auth/auth.service';
import { HttpRequest } from '../../models/http-provider.model'; 
import { AuthService } from '@fpx/core/services';
import { CommonService } from 'src/app/common.service';
import { UserService } from 'src/app/user.service';

@Injectable({
  providedIn: 'root',
})
export class HttpProviderService {
  // baseURL: string = 'http://10.11.12.46:10452';
  defaultContext = '/olive/publisher';
  fileUploadURL: string = '';
  keycloakURL: string = '';
  realm: string = '';
  client: string = '';
  restURL: string = '';
  idleTimeout: number = 0;
  idleTimer: any;
  idleTimeCount: number = 0;
  promptIdleTimeoutB4: number = 30; //in second
  isPromptTimerAlert: boolean = false;
  defaultIdleTimeout: number = 5;

  constructor(
    private httpClient: HttpClient, 
    private _authService: AuthService,
    private _commonService: CommonService,
    private _userService: UserService
  ) {
    // this._getConfig();
  }

  invokeApi(request: HttpRequestPayload): Observable<any> {
    let requestURL = this.getBaseURL();
    requestURL += request.serverContext
      ? request.serverContext
      : this.getDefaultContext();

    requestURL += request.resource;

    /** append the query params */
    if (request.queryParams && request.queryParams.length > 0) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL += request.queryParams ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {
      'Content-Type': 'application/json',
      'authorization': this.authToken,
      'deviceInfo': this._commonService.encodedDeviceDetails,
      'languageId': environment.languageId
    };

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any } = {
      headers: new HttpHeaders(headers),
      observe: 'response',
    };
    requestURL = encodeURI(requestURL);

    try {
      switch (request.method) {
        case 'POST':
          return this.httpClient.post(requestURL, request.body, httpOpts);
        case 'GET':
          return this.httpClient.get(requestURL, httpOpts);
        case 'PUT':
          return this.httpClient.put(requestURL, request.body, httpOpts);
        case 'DELETE':
          return this.httpClient.delete(requestURL, httpOpts);
        default:
          return throwError('METHOD NOT DEFINED');
      }
    } catch (error) {
      return throwError(error);
    }
  }

  invokeRestApi(httpRequest: HttpRequest, httpOption: Map<any, Map<string, any>> = new Map()): Observable<any> {
    let request = httpRequest.httpPayload;
    let requestURL = '';
    if (request.baseURl) {
      requestURL = request.baseURl;
    } else {
      requestURL += this.getBaseURL()
    }
    requestURL += request.serverContext
      ? request.serverContext
      : this.getDefaultContext();

    requestURL += request.resource;

    /** append the path params */
    if (request.pathParams && request.pathParams.length > 0) {
      for (let index = 0; index < request.pathParams.length; index++) {
        requestURL = requestURL.replace(
          `{${request.pathParams[index].key}}`,
          request.pathParams[index].value
        );
      }
    }

    /** append the query params */
    if (request.queryParams && request.queryParams.length > 0) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL +=
        request.queryParams && request.queryParams?.length > 0 ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {
      'Content-Type': 'application/json',
      authorization: this.authToken,
      'deviceInfo': this._commonService.encodedDeviceDetails,
      'languageId': environment.languageId
    };

    // if (request.isAuthTokenRequired) {
    //   headers['authorization'] = this.authToken;
    // }

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        if(param.key == 'Content-Type') delete headers['Content-Type'];
        else headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any } = {
      headers: new HttpHeaders(headers),
      observe: 'response',
    };
    requestURL = encodeURI(requestURL);

    try {
      switch (request.method) {
        case 'POST':
          return this.httpClient.post(requestURL, request.body, httpOpts);
        case 'GET':
          return this.httpClient.get(requestURL, httpOpts);
        case 'PUT':
          return this.httpClient.put(requestURL, request.body, httpOpts);
        case 'DELETE':
          return this.httpClient.delete(requestURL, httpOpts);
        default:
          return throwError('METHOD NOT DEFINED');
      }
    } catch (error) {
      return throwError(error);
    }
  }

  invokeUploadApi(httpRequest: HttpRequest): Observable<any> {
    let request = httpRequest.httpPayload;
    let requestURL = '';
    if (request.baseURl) {
      requestURL = request.baseURl;
    } else {
      requestURL += this.getBaseURL()
    }
    requestURL += request.serverContext
      ? request.serverContext
      : this.getDefaultContext();

    requestURL += request.resource;

    /** append the path params */
    if (request.pathParams && request.pathParams.length > 0) {
      for (let index = 0; index < request.pathParams.length; index++) {
        requestURL = requestURL.replace(
          `{${request.pathParams[index].key}}`,
          request.pathParams[index].value
        );
      }
    }

    /** append the query params */
    if (request.queryParams && request.queryParams.length > 0) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL +=
        request.queryParams && request.queryParams?.length > 0 ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {
      'Content-Type': 'application/json',
      authorization: this.authToken,
      'deviceInfo': this._commonService.encodedDeviceDetails,
      'languageId': environment.languageId
    };

    // if (request.isAuthTokenRequired) {
    //   headers['authorization'] = this.authToken;
    // }

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        if(param.key == 'Content-Type') delete headers['Content-Type'];
        else headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any, reportProgress: boolean} = {
      headers: new HttpHeaders(headers),
      reportProgress: true,
      observe: 'events'
    };
    requestURL = encodeURI(requestURL);

    try {
      switch (request.method) {
        case 'POST':
          return this.httpClient.post(requestURL, request.body, httpOpts);
        case 'GET':
          return this.httpClient.get(requestURL, httpOpts);
        case 'PUT':
          return this.httpClient.put(requestURL, request.body, httpOpts);
        case 'DELETE':
          return this.httpClient.delete(requestURL, httpOpts);
        default:
          return throwError('METHOD NOT DEFINED');
      }
    } catch (error) {
      return throwError(error);
    }
  }

  invokeDownloadApi(httpRequest: HttpRequest): Observable<any> {
    let request = httpRequest.httpPayload;
    let requestURL = '';
    if (request.baseURl) {
      requestURL = request.baseURl;
    } else {
      requestURL += this.getBaseURL();
    }
    requestURL += request.serverContext
      ? request.serverContext
      : this.getDefaultContext();

    requestURL += request.resource;

    /** append the path params */
    if (request.pathParams && request.pathParams.length > 0) {
      for (let index = 0; index < request.pathParams.length; index++) {
        requestURL = requestURL.replace(
          `{${request.pathParams[index].key}}`,
          request.pathParams[index].value
        );
      }
    }

    /** append the query params */
    if (request.queryParams && request.queryParams.length > 0) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL +=
        request.queryParams && request.queryParams?.length > 0 ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {};

    if (request.isAuthTokenRequired) {
      headers['authorization'] = this.authToken;
    }

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any; responseType: 'blob' } =
      {
        headers: new HttpHeaders(headers),
        responseType: 'blob',
        observe: 'response',
      };
    requestURL = encodeURI(requestURL);

    try {
      // if (this._commonService.isHybrid()) {
      //   // return this.secureFileDownload(requestURL, "GET", request.body, headers, "AccountStatement.pdf");
      // }else {
        switch (request.method) {
          case 'POST':
            return this.httpClient.post(requestURL, request.body, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          case 'GET':
            return this.httpClient.get(requestURL, httpOpts);
          case 'PUT':
            return this.httpClient.put(requestURL, request.body, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          case 'DELETE':
            return this.httpClient.delete(requestURL, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          default:
            return throwError('METHOD NOT DEFINED');
        }
      // }
    } catch (error) {
      return throwError(error);
    }

    // return this.httpClient.get(requestURL, httpOpts).pipe(
    //   tap((res: any) => {
    //     let fileName = res.headers.get('content-disposition')?.split(';')[1]?.split('=')[1] || 'sample' ;
    //     let blob: Blob = new Blob([res.body]);
    //     let a = document.createElement('a');
    //     a.download = fileName ;
    //     a.href = window.URL.createObjectURL(blob);
    //     a.click();
    //   })
    // );
  }

  get authToken(): string {
    // return this._userService.getToken();
    return sessionStorage.getItem('access_token') && sessionStorage.getItem('access_token') != 'undefined' ? 'Bearer ' + sessionStorage.getItem('access_token') : "";
  }

  private _getConfig() {
    let origin = '';
    const url = origin + 'assets/config/config.json';
    return this.httpClient.get(url).subscribe((res) => {
      this._refreshVar(res);
    });
  }

  private _refreshVar(data: any) {
    this.fileUploadURL = data.fileUploadURL;
    this.keycloakURL = data.KEYCLOAK_URL;
    this.realm = data.KEYCLOAK_REALM;
    this.client = data.KEYCLOAK_CLIENT_ID;
    this.restURL = data.baseURL;

    if (data.idleTimeoutInMin)
      this.idleTimeout = parseInt(data.idleTimeoutInMin) * 60;
    else this.idleTimeout = this.defaultIdleTimeout * 60;

    if (data.idleTimeoutPromptB4Sec)
      this.promptIdleTimeoutB4 = parseInt(data.idleTimeoutPromptB4Sec);
    else this.promptIdleTimeoutB4 = 60;

    this._clearTimer();
  }

  private _clearTimer() {
    this.isPromptTimerAlert = false;
    if (this.idleTimer) clearInterval(this.idleTimer);
  }

  getBaseURL(){
    return environment.baseURL;
  }
  getDefaultContext(){
    return environment.defaultPublisher;
  }
}
